import { useEffect } from "react";

export default function useToastTimer(toast, setToast) {
  useEffect(() => {
    if (!toast.message) return;

    const timer = setTimeout(() => {
      setToast({ message: "", type: "success" });
    }, 3000);

    return () => clearTimeout(timer);
  }, [toast, setToast]);
}
